export const getAdminFavoriteOverride = (
  courseId: string | number,
): boolean | null => {
  try {
    const raw = localStorage.getItem('admin_favorite_courses_override')
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (parsed && typeof parsed[courseId] !== 'undefined') {
      return Boolean(parsed[courseId])
    }
  } catch (e) {
    console.error(e)
  }
  return null
}

export const setAdminFavoriteOverride = (
  courseId: string | number,
  isFav: boolean,
) => {
  try {
    const raw = localStorage.getItem('admin_favorite_courses_override')
    const parsed = raw ? JSON.parse(raw) : {}
    parsed[courseId] = isFav
    localStorage.setItem(
      'admin_favorite_courses_override',
      JSON.stringify(parsed),
    )
  } catch (e) {
    console.error(e)
  }
}
